import { config } from "../config";

// Deixa explícito quando a aplicação está rodando com autenticação e/ou API
// simuladas — nunca deve aparecer em produção real.
export function MockBanner() {
  if (config.authMode !== "mock" && !config.useMockApi) return null;
  const parts = [
    config.authMode === "mock" ? "autenticação simulada" : null,
    config.useMockApi ? "dados fictícios" : null,
  ].filter(Boolean);
  return (
    <div className="mock-banner" role="status">
      Ambiente simulado — {parts.join(" e ")}. Não usar em produção.
    </div>
  );
}
